import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HeartHandshake, PhoneCall, Sparkles, ShoppingBag, Users, CalendarHeart, ArrowRight } from "lucide-react";

const points = [
  { icon: Sparkles, title: "Your independence, respected", text: "Your home, your routine, your decisions. We simply make the hard parts easier." },
  { icon: Users, title: "A friendly face who knows you", text: "Your own Care Manager — someone who knows how you take your chai and which doctor you prefer." },
  { icon: ShoppingBag, title: "Help with everyday things", text: "Bank visits, bills, groceries, a ride to the temple — just ask, and it's arranged." },
  { icon: CalendarHeart, title: "Companionship, not supervision", text: "Walks, conversation, festivals and outings with people who genuinely enjoy your company." },
  { icon: PhoneCall, title: "Someone to call, always", text: "One number for anything you need — day or night. No apps required if you don't want them." },
  { icon: HeartHandshake, title: "Your children stay close", text: "They receive simple updates after every visit, so they worry less and call more." },
];

export default function ForParents() {
  return (
    <div data-testid="for-parents-page">
      <section className="p1-container py-14 lg:py-20">
        <div className="max-w-3xl">
          <p className="p1-eyebrow">For Parents</p>
          <h1 className="mt-3 font-heading text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">
            Live life your way. <span className="text-emerald-900">We'll handle the rest.</span>
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-stone-600">
            ParentOne is not about being looked after — it's about having a trusted local team on your side, so you can keep doing everything you love, with less hassle.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="tel:+918690545601" className="p1-btn-primary" data-testid="parents-call-cta"><PhoneCall className="h-4 w-4" /> Call us: +91 86905 45601</a>
            <Link to="/plans" className="p1-btn-outline" data-testid="parents-plans-cta">See how it works</Link>
          </div>
        </div>
      </section>
      <section className="border-t border-stone-200 bg-white py-16">
        <div className="p1-container grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {points.map((p, i) => (
            <motion.div key={p.title} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }} className="p1-card p-6" data-testid={`parents-point-${i}`}>
              <p.icon className="h-7 w-7 text-emerald-800" />
              <h3 className="mt-3 font-heading text-lg font-semibold text-stone-900">{p.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-stone-600">{p.text}</p>
            </motion.div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <p className="font-editorial text-2xl italic text-emerald-950">“Ask your son or daughter to book a free assessment — or call us yourself. We speak Hindi, Marwari and English.”</p>
          <Link to="/onboarding" className="p1-btn-primary mt-6" data-testid="parents-assessment-cta">Book a Free Assessment <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
